module.exports = __webpack_public_path__ + "static/media/pie-chart.3ce4d577.svg";